import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import ChatBot from 'react-simple-chatbot';


  
  const steps = [
    {
      id: '0',
      message: 'Hey there :)',
      trigger: '1',
    },
    
    {
      id: '1',
      message: 'My name is Eleos, what about you?',
      trigger: '2',
    },
    {
      id: '2',
      user: true,
      trigger: '3',
    },
    {
      id: '3',
      message: 'I\'m happy that you are here, {previousValue}.',
      trigger: '4',
    },
    {
      id: '4',
      message: 'I\'m curious, what city are you from?',
      trigger: '5',
    },
  
    {
      id: '5',
      options: [
         { value: 1, label: 'Lower Mainland', trigger: 'vanboi' },
                { value: 2, label: 'Province of BC', trigger: 'lowMain' },
                { value: 3, label: 'Rest of Canada', trigger: 'o' }
      ]
     
    },
    {
      id: 'lowMain',
      message: 'That\'s wonderful, I know about some of the resources in BC.',
      trigger: '6',
    },
    {
      id: 'vanboi',
      message: 'That\'s wonderful, I know about some of the resources in Lower Mainland.',
      trigger: '6',
    },
    {
      id: 'o',
      message: 'That\'s wonderful, I know about some of the resources in Canada.',
      trigger: '6',
    },
    {
      id: '6',
      message: 'I want to know a little more about you! Which one of these are you?' ,
      trigger: '7',
    },
    {
      id: '7',
       options: [
            { value: 4, label: 'Law Enforcement', trigger: 'law' },
            { value: 5, label: 'EMT', trigger: 'emt' },
            { value: 6, label: 'Veteran', trigger: 'vet' },
          ],
      
    },
    {
      id: 'law',
      message: 'WOW ... first of all, thank you for your service to our community, Law Enforcement is a challenging job. Now, which one of these are you suffering with?' ,
      trigger: '8',
    },
    {
      id: 'emt',
      message: 'WOW ... first of all, thank you for your service to our community, EMT is a challenging job. Now, which one of these are you suffering with?' ,
      trigger: '8',
    },
    {
      id: 'vet',
      message: 'WOW ... first of all, thank you for your service to our community. You must be going through a lot, being a veteran. Now, which one of these are you suffering with?' ,
      trigger: '8',
    },
    {
      id: '8',
       options: [
            { value: 7, label: 'PTSD', trigger: 'pt' },
            { value: 8, label: 'Substance Abuse', trigger: 'sa' },
            { value: 9, label: 'Anxiety', trigger: 'an' },
            { value: 10, label: 'Relationship issues', trigger: 'ti' },
          ],
    },
    {
      id: 'pt',
      message: 'It\'s hard being emotionally vulnerable, so I appericiate your honesty. I\'ll try to screen you for PTSD' ,
      trigger: 'linkpt',
    },
    {
      id: 'sa',
      message: 'It\'s hard being emotionally vulnerable, so I appericiate your honesty. I\'ll try to get you the appropriate resources for Substance Abuse' ,
      trigger: 'linksa',
    },
    {
      id: 'an',
      message: 'It\'s hard being emotionally vulnerable, so I appericiate your honesty. I\'ll try to screen you for Anxiety' ,
      trigger: 'linkan',
    },
    {
      id: 'ti',
      message: 'It\'s hard being emotionally vulnerable, so I appericiate your honesty. I\'ll try to get you the appropriate resources for Relationship Issues' ,
      trigger: 'linkti',
    },

    // Quiz for Anxiety
    {
      id: 'linkan',
      message: 'Let\'s get started. Are you currently being treated, or sought help in the past for bipolar disorder?' ,
      trigger : '9',
    },

    // Quiz for PTSD
    {
      id: 'linkpt',
      message: 'Are you currently being treated, or sought help in the past for bipolar disorder?' ,
      trigger : 'qq',
    },
    {
      id: 'qq',
      options: [
        {value: 1 , label : 'yes' , trigger: 'linkptt'},
        {value: 2, label : 'no' , trigger: 'linkptt'}
    ]
      
    },

    // Last Substance Abuse resource 
    {
      id: 'linksa',
      message: 'I found you a resource, I encourage you to contact 1-800-663-1441.' ,
      end: true,
    },

    // Last Relationshio Issues resource
    {
      id: 'linkti',
      message: 'I encourage you to call Options Community Services, their phone number is 1-877-820-7444' ,
      end: true,
    },
    {
      id: '9',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes'},
          {value: 2, label : 'no' , trigger: 'yes'}
      ]
      
    },
    {
      id: 'yes',
      message: 'Are you currently being treated, or sought help in the past for lwo mood or depression?' ,
      trigger : '10',
    },
    {
      id: '10',
      options: [
          {value: 1 , label : 'I have never sought help for low mood or depression' , trigger: 'yup'},
          {value: 2 , label : 'I am currently being treated for low mood or depression' , trigger: 'yup'},
          {value: 3, label : 'I have sought help or been treated in the past' , trigger: 'yup'}
      ]
    },
      {
      id: 'yup',
      message: 'Are you currently being treated, or sought help in the past, for bipolar disorder?' ,
      trigger : '11',
    },
    {
      id: '11',
      options: [
          {value: 1 , label : 'I have never been treated for bipolar disorder' , trigger: 'po'},
          {value: 2 , label : 'I am currently being treated for bipolar disorder' , trigger: 'po'},
          {value: 3, label : 'I have sought help or been treated in the past' , trigger: 'po'}
      ]
    },
    {
      id: 'po',
      message: 'Are you currently being treated, or sought help in the past, for anxiety?' ,
      trigger : '12',
    },
    {
      id: '12',
      options:[
          {value: 1 , label : 'I have never been treated for anxiety' , trigger: 'oppa'},
          {value: 2 , label : 'I am currently being treated for anxiety' , trigger: 'oppa'},
          {value: 3, label : 'I have sought help or been treated in the past' , trigger: 'oppa'}
      ]
    },
   {
      id: 'oppa',
      message: 'Please indicate if you are currently being treated, or ever have been treated, for any of the following conditions.' ,
      trigger : '13',
    },
      {
      id: '13',
      options:[
          {value: 1 , label : 'Substance use problems' , trigger: 'zaddy'},
          {value: 2 , label : 'Cancer' , trigger: 'zaddy'},
          {value: 3, label : 'Diabetes' , trigger: 'zaddy'},
          {value: 4 , label : 'Chronic pain' , trigger: 'zaddy'},
          {value: 5 , label : 'HIV' , trigger: 'zaddy'},
          {value: 6, label : 'A thyroid condition' , trigger: 'zaddy'},
          {value: 7 , label : 'Psychosis' , trigger: 'zaddy'},
          {value: 8 , label : 'Another condition' , trigger: 'zaddy'}
      ]
    },
     {
      id: 'zaddy',
      message: 'I encourage you to call 1-866-225-0709 and seek help. I know you’re strong, and you can do this!' ,
      end : true,
    },
  
  // ~~~~~~~~~~~~ ptsd ~~~~~~~~~~~~~~~~~~~
  {
      id: 'linkptt',
      message: 'Have you experienced or been exposed to a traumatic event?' ,
      trigger : '222',
    },
    {
      id: '222',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yesS'},
          {value: 2, label : 'no' , trigger: 'yesS'}
      ]
      
    },
  {
      id: 'yesS',
      message: 'During the traumatic event, did you experience or witness serious injury or death, or the threat of injury or death?' ,
      trigger : '22',
    },
    {
      id: '22',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes2'},
          {value: 2, label : 'no' , trigger: 'yes2'}
      ]
      
    },
  {
      id: 'yes2',
      message: 'During the traumatic event did you feel intense fear, helplessness, and/or horror?' ,
      trigger : '23',
    },
    {
      id: '23',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes3'},
          {value: 2, label : 'no' , trigger: 'yes3'}
      ]
      
    },
    {
      id: 'yes3',
      message: 'Do you regularly experience intrusive thoughts or images about the traumatic event?' ,
      trigger : '24',
    },
    {
      id: '24',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes4'},
          {value: 2, label : 'no' , trigger: 'yes4'}
      ]
      
    },
      {
      id: 'yes4',
      message: ' Do you sometimes feel like you are re-living the event or that it is happening all over again?' ,
      trigger : '25',
    },
    {
      id: '25',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes5'},
          {value: 2, label : 'no' , trigger: 'yes5'}
      ]
      
    },
       {
      id: 'yes5',
      message: 'Do you have recurrent nightmares or distressing dreams about the traumatic event?' ,
      trigger : '26',
    },
    {
      id: '26',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes6'},
          {value: 2, label : 'no' , trigger: 'yes6'}
      ]
      
    },
    {
      id: 'yes6',
      message: 'Do you have recurrent nightmares or distressing dreams about the traumatic event?' ,
      trigger : '27',
    },
    {
      id: '27',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes7'},
          {value: 2, label : 'no' , trigger: 'yes7'}
      ]
      
    },
      {
      id: 'yes7',
      message: 'Do you try to avoid thoughts, feelings, or conversations that remind you of the traumatic event?' ,
      trigger : '28',
    },
    {
      id: '28',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes8'},
          {value: 2, label : 'no' , trigger: 'yes8'}
      ]
      
    },
  
   {
      id: 'yes8',
      message: ' Do you try to avoid activities, people, or places that remind you of the traumatic event?' ,
      trigger : '29',
    },
    {
      id: '29',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes9'},
          {value: 2, label : 'no' , trigger: 'yes9'}
      ]
      
    },
    {
      id: 'yes9',
      message: 'Are you unable to remember something important about the traumatic event?' ,
      trigger : '30',
    },
    {
      id: '30',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes10'},
          {value: 2, label : 'no' , trigger: 'yes10'}
      ]
      
    },
      {
      id: 'yes10',
      message: 'Since the trauma took place, do you feel less interested in activities or hobbies that you once enjoyed?' ,
      trigger : '31',
    },
    {
      id: '31',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes11'},
          {value: 2, label : 'no' , trigger: 'yes11'}
      ]
      
    },
    // 
    // 
    //
       {
      id: 'yes11',
      message: ' Since the trauma took place, do you feel distant from other people or have difficulty trusting them?' ,
      trigger : '32',
    },
    {
      id: '32',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes12'},
          {value: 2, label : 'no' , trigger: 'yes12'}
      ]
      
    },
       {
      id: 'yes12',
      message: 'Since the trauma took place, do you have difficulty experiencing or showing emotions?' ,
      trigger : '33',
    },
    {
      id: '33',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes13'},
          {value: 2, label : 'no' , trigger: 'yes13'}
      ]
      
    },
       {
      id: 'yes13',
      message: 'Do you feel that your future will not be "normal" -- that you wont have a career, marriage, children, or a normal life span?' ,
      trigger : '34',
    },
    {
      id: '34',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes14'},
          {value: 2, label : 'no' , trigger: 'yes14'}
      ]
      
    },
       {
      id: 'yes14',
      message: 'Since the traumatic event, have you had difficulty falling or staying asleep?' ,
      trigger : '35',
    },
    {
      id: '35',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes15'},
          {value: 2, label : 'no' , trigger: 'yes15'}
      ]
      
    },
       {
      id: 'yes15',
      message: ' Have you felt irritable or have you had outbursts of anger?' ,
      trigger : '36',
    },
    {
      id: '36',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes16'},
          {value: 2, label : 'no' , trigger: 'yes16'}
      ]
      
    },
       {
      id: 'yes16',
      message: 'Have you had difficulty concentrating, since the trauma?' ,
      trigger : '37',
    },
    {
      id: '37',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes17'},
          {value: 2, label : 'no' , trigger: 'yes17'}
      ]
      
    },
       {
      id: 'yes17',
      message: 'Do you feel guilty because others died or were hurt during the traumatic event but you survived it?' ,
      trigger : '38',
    },
    {
      id: '38',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes18'},
          {value: 2, label : 'no' , trigger: 'yes18'}
      ]
      
    },
       {
      id: 'yes18',
      message: 'Do you often feel jumpy or startle easily?' ,
      trigger : '39',
    },
    {
      id: '39',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes20'},
          {value: 2, label : 'no' , trigger: 'yes20'}
      ]
      
    },
       {
      id: 'yes20',
      message: 'Do you often feel hypervigilant, that is, are you constantly feeling and acting ready for any kind of threat?' ,
      trigger : '40',
    },
    {
      id: '40',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes21'},
          {value: 2, label : 'no' , trigger: 'yes21'}
      ]
      
    },
       {
      id: 'yes21',
      message: ' Have you been experiencing symptoms for more than one month?' ,
      trigger : '41',
    },
    {
      id: '41',
      options: [
          {value: 1 , label : 'yes' , trigger: 'yes22'},
          {value: 2, label : 'no' , trigger: 'yes22'}
      ]
      
    },
      {
      id: 'yes22',
      message: ' Do your symptoms interfere with normal routines, work or school, or social activities?' ,
      trigger : '42',
    },
    {
      id: '42',
      options: [
          {value: 1 , label : 'yes' , trigger: 'end'},
          {value: 2, label : 'no' , trigger: 'end'}
      ]
      
    },
    {
        id: 'end',
        message:'TI encourage you to call the Employee Assistance Services of Health Canada, their phono number is 1-800-268-7708. Stay strong!',
       end : true
        
      }
  ];

ReactDOM.render(
  
    
  
     <div class="container" id="daddybitch">
            <div class="container__item landing-page-container" >
                <div class="content__wrapper" id="daddy">

                    <header class="header">
                        <div class="menu-icon header__item">
                            <span class="menu-icon__line"></span>
                        </div>
                        <h1 class="heading header__item">Hi, I'm <font color="purple">Eleos</font>, a friendly chatbot <br />to help you through difficult times.</h1>    
                    </header>
                    <b>               
                     <center>
                       I'm designed to help <font color="purple">first responders, paramedics, and veterans</font> like you <br />to help cope with feelings of anxiety and depression. <br /><br />
                     
                     I'm looking forward to chatting with you. :) <br />
                     I will respond to the emotions you express and try to share possible resources.
                     </center>      
                    

                    </b>
                    

                    <div class="ellipses-container">

                        
                        <div id="fuckingbot">
                        <ChatBot steps={steps} />
                        </div>
                        <div class="ellipses ellipses__outer--thin">

                            <div class="ellipses ellipses__orbit"></div>

                        </div>
                        

                        <div class="ellipses ellipses__outer--thick"></div>
                        
                    </div>

                    <div >
                        

                        <div class="timeline">
                            <span class="timeline__unit"></span>
                            <span class="timeline__unit timeline__unit--active"></span>
                            <span class="timeline__unit"></span>
                        </div>
                    </div>

                  </div>
               </div>
            </div>,
  
  document.getElementById('root') 
  
);







// WEBPACK FOOTER //
// ./src/index.js